import ReactJson from 'react-json-view';

interface Props {
  src: Object;
}

function EnhancedReactJson({ src }: Props) {
  return (
    <ReactJson
      enableClipboard={false}
      displayDataTypes={false}
      displayObjectSize={false}
      name={null}
      shouldCollapse={false}
      iconStyle='circle'
      src={src}
    />
  );
}

export default EnhancedReactJson;
